// @flow

import isCarouselPin from 'app/common/react/components/common/Carousel/utils/isCarouselPin';
import { isVideoPin } from 'app/common/lib/util/PinUtils';
import { type Pin } from 'app/common/react/components/PinRep/types';

export type PinTypes = {|
  isCarousel: boolean,
  isGif: boolean,
  isOneTap: boolean,
  isOwnPin: boolean,
  isProduct: boolean,
  isPromoted: boolean,
  isRecipe: boolean,
  isStoryPin: boolean,
  isVideo: boolean,
|};

const getDefaultPinTypes = (): PinTypes => ({
  isCarousel: false,
  isGif: false,
  isOneTap: false,
  isOwnPin: false,
  isProduct: false,
  isPromoted: false,
  isRecipe: false,
  isStoryPin: false,
  isVideo: false,
});

export default function getPinTypes(pin: Pin): PinTypes {
  const {
    access,
    attribution,
    buyable_product,
    embed,
    is_eligible_for_web_closeup,
    rich_summary,
    story_pin_data_id,
    videos,
  } = pin;
  const pinTypes = getDefaultPinTypes();

  if (isCarouselPin(pin)) {
    pinTypes.isCarousel = true;
  }

  if (is_eligible_for_web_closeup) {
    pinTypes.isOneTap = true;
  }

  if (isVideoPin(videos)) {
    pinTypes.isVideo = true;
  }

  const embedded = embed || (attribution && attribution.embed) || null;
  if (embedded && embedded.type === 'gif') {
    pinTypes.isGif = true;
  }

  if (!!buyable_product || (!!rich_summary && rich_summary.type_name === 'product')) {
    pinTypes.isProduct = true;
  }

  if (!!rich_summary && rich_summary.type_name === 'recipe') {
    pinTypes.isRecipe = true;
  }

  if (!!pin.promoter && !pin.is_downstream_promotion) {
    pinTypes.isPromoted = true;
  }

  if ((access || []).includes('write')) {
    pinTypes.isOwnPin = true;
  }

  if (story_pin_data_id) {
    pinTypes.isStoryPin = true;
  }

  return pinTypes;
}
